import invariant from "invariant";
import { createContext, useContext } from "react";

export const TabIdContext = createContext<number | null>(null);

function useTabId(): number {
  const tabId = useContext(TabIdContext);
  invariant(tabId !== null, "missing tabId in TabIdContext");
  return tabId;
}

export function useOptionalTabId(): number | null {
  const tabId = useContext(TabIdContext);
  return tabId;
}

export default useTabId;
